/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component } from 'react';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import BannerTitle from './BannerTitle';
import BannerButton from './BannerButton';
import { getInboxChannelsTableUrl } from 'conversations-external-deep-links/urls';
import SendDisconnectedAccountEmailPromptContainer from '../../access-control/components/SendDisconnectedAccountEmailPromptContainer';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getEmail } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
import { trackLinkClick } from '../../usage-tracking/utils/trackLinkClick';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getDisconnectedEmailAccountSend } from '../constants/Events';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getClickedAlertBannerCta } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class DisconnectedEmailAccountBanner extends Component {
  constructor(props) {
    super(props);
    this.openSendDisconnectEmailPrompt = () => {
      trackEvent(getClickedAlertBannerCta({
        ctaAction: 'ask admin to reconnect email'
      }));
      this.setState({
        openSendDisconnectEmailPrompt: true
      });
    };
    this.closeSendDisconnectEmailPrompt = () => {
      this.setState({
        openSendDisconnectEmailPrompt: false
      });
    };
    this.handleEmailReconnect = event => {
      const {
        currentInboxId
      } = this.props;
      trackLinkClick({
        event,
        name: 'clicked-alert-banner-cta',
        meta: {
          action: 'clicked alert banner cta',
          'cta-action': 'reconnect email'
        },
        href: `${getInboxChannelsTableUrl({
          inboxId: currentInboxId
        })}`
      });
    };
    this.trackSendEmail = ({
      emailToReconnect,
      emailSentTo
    }) => {
      trackEvent(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ key: string; properties: { ema... Remove this comment to see the full error message
      getDisconnectedEmailAccountSend({
        emailToReconnect,
        emailSentTo
      }));
    };
    this.state = {
      openSendDisconnectEmailPrompt: false
    };
  }
  render() {
    const {
      channel,
      isConversationsAdmin
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(UIAlert, {
        titleText: /*#__PURE__*/_jsx(BannerTitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.accountStatusBanner.title",
            options: {
              email: getEmail(channel)
            }
          })
        }),
        type: "danger",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.accountStatusBanner.message"
        }), /*#__PURE__*/_jsx(BannerButton, {
          onClick: this.handleEmailReconnect,
          "data-test-id": "reconnect-email-channel-button",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.accountStatusBanner.button"
          })
        }), !isConversationsAdmin && /*#__PURE__*/_jsx(BannerButton, {
          use: "tertiary-light",
          onClick: this.openSendDisconnectEmailPrompt,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.accountStatusBanner.secondaryButton"
          })
        })]
      }), this.state.openSendDisconnectEmailPrompt ? /*#__PURE__*/_jsx(SendDisconnectedAccountEmailPromptContainer, {
        email: channel.email,
        onReject: this.closeSendDisconnectEmailPrompt,
        onConfirm: this.closeSendDisconnectEmailPrompt,
        inboxId: channel.inboxId,
        trackSendEmail: this.trackSendEmail
      }) : null]
    });
  }
}
DisconnectedEmailAccountBanner.displayName = 'DisconnectedEmailAccountBanner';